import { useLocation } from 'js/lib/useRouter';

export const useIsOnDegreesPage = () => {
  const { pathname } = useLocation();
  return pathname.includes('degrees');
};
